// This is just an example,
// so you can safely delete all default props below

export default {
    title: 'My account',
    profile: 'My profile',
    orders: 'My orders',
    change_password: 'Change password',
    delete_account: 'Delete Account'
}
